/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Source_LabelInputs */



/**
* | output |
* | --- |
* | "Connector" |
*
* @param {Agent_Event_Trigger_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_source_label = /** @type {((inputs?: Agent_Event_Trigger_Source_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Source_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konnektor")
	return /** @type {LocalizedString} */ ("Connector")
});